export const GB_KEYS = {
  // Delivery Integration API not available for this environment (WYN-66101)
  DELIVERY_INTEGRATION_DISABLED: 'delivery-integration-disabled',
} as const;

